// extracted by mini-css-extract-plugin
module.exports = {"container":"style__container__YDZhz","veryHigh":"style__veryHigh__2HoVu","high":"style__high__i29zP","mid":"style__mid__NRGhX","average":"style__average__6u2Sn"};